module.exports = __webpack_public_path__ + "img/graduate-2017-new-students.d7c4be58.jpg";